import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rol } from 'app/model/rol';
import { throwError } from 'rxjs';
import { urls } from 'assets/url/urls'

@Injectable()
export class RolService {
  // Constante de la api de la base de datos
  // private REST_API_SERVER = 'https://json-portal-empleado.onrender.com';
  private REST_API_SERVER = urls.baseUrl;
  private TENANT = urls.tenant;

  headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
    'X-TENANT-ID' : this.TENANT
  }
  requestOptions = {
    headers: new  HttpHeaders (this.headers),
  };


  /**
   * Constructor
   * @param httpClient
   */
  constructor(private httpClient: HttpClient) { }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  /**
   * Trae los usuarios de la base de datos
   * @returns Usuario
   */
  public getRoles() {
    return this.httpClient.get(this.REST_API_SERVER + '/roles', this.requestOptions);
  }

  /**
   * Trae el usuario con la id seleccionada
   * @param id
   * @returns Usuario por id
   */
  public getRolById(id) {
        return this.httpClient.get(this.REST_API_SERVER + '/roles/' + id, this.requestOptions);
  }

  /**
   * Crea el usuario en la base de datos
   * @param Rol
   * @returns Usuario
   */
  public addRol(rol: Rol) {
    return this.httpClient.post<Rol>(this.REST_API_SERVER + '/roles', rol, this.requestOptions);
  }

  /**
   * Actualiza el usuario con la id seleccionada en la base de datos
   * @param id
   * @param Rol
   * @returns Usuario actualizado
   */
  public updateRolById(id, rol: Rol) {
    return this.httpClient.put(this.REST_API_SERVER + '/roles/' + id, rol, this.requestOptions);
  }

  /**
   * Crea el usuario en la base de datos
   * @param Rol
   * @returns Usuario
   */
  public createRol(rol: Rol) {
    return this.httpClient.post(this.REST_API_SERVER + '/roles/', Rol, this.requestOptions);
  }

  /**
   * Borra el usuario de la base de datos
   * @param id
   * @returns Usuario
   */
  public deleteRolById(id) {
    return this.httpClient.delete(this.REST_API_SERVER + '/roles/' + id, this.requestOptions);
  }

}
